export default "__VITE_ASSET__CbMQor9c__"